module.exports = require('../../full/object/get-prototype-of');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/object/get-prototype-of.js
// module id = 521
// module chunks = 0 1